import React from 'react'
import TableContainer from './Table'

const InsideTable = (props) => {
  const { data, expandedRow, dateMatch, isMobile, activeworkfromhome } = props;
  const columns = React.useMemo(() => {
    const result = [
      {
        Header: " ",
        accessor: " ",
        disableFilters: true,
        sort: false,
        Cell: () => {
          return (
            <span
              className="bx bx-plus-circle font-size-18"
              style={{ opacity: 0 }}
            />
          )
        },
      },
      {
        Header: "Employee Id",
        accessor: "userIdentificationNumber",
        disableFilters: true,
        hidden: false,
        style: {
          minWidth:  isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        sort: true,
        Cell: cellProps => {
          return <span style={{ opacity: 0 }}>HR-R-00008</span>
        },
      },
      {
        Header: "Employee name",
        accessor: "employeeName",
        disableFilters: true,
        hidden: false,
        style: {
          minWidth:  isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        sort: true,
        Cell: cellProps => {
          return <span style={{ opacity: 0 }}>HR-R-00008</span>
        },
      },

      {
        Header: "Date",
        accessor: "date",
        disableFilters: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        sort: true,
      },

      {
        Header: "Start Time",
        accessor: "starttime",
        disableFilters: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        sort: true,
      },
      {
        Header: "End Time",
        accessor: "endtime",
        disableFilters: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        sort: true,
      },
      {
        Header: "Total Hours",
        accessor: "totalHours",
        disableFilters: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        sort: true,
      },
      {
        Header: "WFH",
        accessor: "hoursWorkedFromHome",
        disableFilters: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        sort: true,
      },
      {
        Header: "Shift",
        accessor: "shift",
        disableFilters: true,
        // hidden: activeworkfromhome.id == 1 ? false : true,
        sort: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },       
      },
      {
        Header: "No of days",
        accessor: "numberOFDays",
        disableFilters: true,
        hidden: activeworkfromhome.id === 1 ? true : false,
        sort: true,
      },
    ]
    return result
  }, [expandedRow, dateMatch])

  return <TableContainer
    data={data}
    columns={columns}
    tableHeader="hide"
  />
}
export default InsideTable